require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-first-cu-names-new-vice-president-of-human-resources.json") })
        }
      }, "path---es-articles-financial-center-first-cu-names-new-vice-president-of-human-resources");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-first-cu-names-new-vice-president-of-human-resources!./.cache/json/es-articles-financial-center-first-cu-names-new-vice-president-of-human-resources.json
// module id = 2097
// module chunks = 231608221292675